import * as React from 'react'
import styled from '@xstyled/styled-components'
import { RatioPadding } from '../Layout'

export interface IconButtonBaseProps {
  onClick?: () => void
  label?: string | null
  children?: React.ReactNode
  disabled?: boolean
  labelColor?: string
}

const ButtonWrapper = styled.button`
  min-width: 100px;
  text-align: center;
`

const IconWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  width: 120px;
  height: 120px;
`

const IconInner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const ButtonLabel = styled.span<{ $labelColor?: string }>`
  font-family: sans;
  font-size: 6;
  display: block;
  text-align: center;
  margin-top: 3;
  color: ${({ $labelColor }) => $labelColor || 'inherit'};
`

export const IconButtonBase: React.FC<IconButtonBaseProps> = ({
  disabled,
  onClick,
  children,
  label,
  labelColor
}) => {
  return (
    <ButtonWrapper
      disabled={disabled}
      type="button"
      data-foo="bar"
      onClick={onClick}
    >
      <IconWrapper>
        <RatioPadding ratio={1} />
        <IconInner>{children}</IconInner>
      </IconWrapper>
      {label ? <ButtonLabel $labelColor={labelColor}>{label}</ButtonLabel> : null}
    </ButtonWrapper>
  )
}
